export default __webpack_public_path__ + "static/media/KDS-100k.fbc47b0d.png";